export enum SexType {
    Male = 0, Female = 1
}

export class MeteorUserLayout {
    isFixed?: boolean = false;
    isCollapsed?: boolean = false;
    isBoxed?: boolean = false;
    isRTL?: boolean = false;
    horizontal?: boolean = false;
    isFloat?: boolean = false;
    asideHover?: boolean = false;
    theme?: string = "";
    asideScrollbar?: boolean = false;
    isCollapsedText?: boolean = false;
    useFullLayout?: boolean = false;
    hiddenFooter?: boolean = false;
    offsidebarOpen?: boolean = false;
    asideToggled?: boolean = false;
    viewAnimation?: string = "";
    hideSidebarUserBlock?: boolean = false;
}

export class MeteorUserProfile {
    firstName?: string = "";
    lastName?: string = "";
    title?: string = "";
    displayName?: string = "";
    birthday?: string = "";
    sex?: SexType = null;
    lang?: string = "";
    picture?: string = "";

    layout?: MeteorUserLayout = new MeteorUserLayout();
}

export class MeteorUser implements Meteor.User {
    _id?: string = null;
    username?: string = "";
    emails?: Meteor.UserEmail[] = [];
    profile?: MeteorUserProfile = new MeteorUserProfile();
    services?: any;

    constructor(data?: any) {
        if (data) {
            Object.assign(this, data);
        }
    }
}